var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60.896832mm",
    height: "78.14679mm",
    viewBox: "0 0 60.896832 78.14679",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-87.344157,-98.562502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4783"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 6.614583,
    cy: 142.21877,
    cx: 93.95874,
    id: "path3825",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 142.13852,
    cx: 109.80789,
    id: "path3825-4",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 142.28558,
    cx: 125.79067,
    id: "path3825-4-3",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 142.27216,
    cx: 141.6264,
    id: "path3825-4-3-6",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 170.09471,
    cx: 109.90158,
    id: "path3825-4-3-6-6",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 170.05441,
    cx: 125.80412,
    id: "path3825-4-3-6-6-3",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 156.15674,
    cx: 101.90933,
    id: "path3825-3",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 156.07649,
    cx: 117.75848,
    id: "path3825-4-6",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 156.22356,
    cx: 133.74127,
    id: "path3825-4-3-4",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 128.24049,
    cx: 101.9503,
    id: "path3825-3-3",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 128.16025,
    cx: 117.79945,
    id: "path3825-4-6-9",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.6145835,
    cy: 128.30731,
    cx: 133.78223,
    id: "path3825-4-3-4-2",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3944",
    d: "m 97.398329,114.4375 c 6.354871,5.69946 12.549121,6.67925 17.991671,4.23334 l -1.5875,-2.11667 c -6.99267,-3.66928 -11.78027,-4.1741 -16.404171,-2.11667 z",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3944-9",
    d: "m 138.40875,114.4375 c -6.35487,5.69946 -12.54912,6.67925 -17.99167,4.23334 l 1.5875,-2.11667 c 6.99267,-3.66928 11.78028,-4.1741 16.40417,-2.11667 z",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4766",
    d: "m 117.77125,116.28959 c -5.83457,-6.21101 -5.46321,-11.98586 0,-17.727088 6.122,6.431298 5.87136,12.146168 0,17.727088 z",
    style: {
      fill: "#35c0ed",
      fillOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35823eb8009a2b675fb6211368788871.svg";
export { ForwardRef as ReactComponent };